var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-item-wrapper"},[_c('div',{staticClass:"card-item-main"},[_vm._t("default")],2),_c('el-button',{staticClass:"card-item-btn",attrs:{"type":"primary","plain":""},on:{"click":_setup.handleMore}},[_vm._v(_vm._s(_vm.$t('enterprise.view')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }